import React from 'react';
import AddressItem from './AddressItem';
import SectionContainer from './SectionContainer';

interface AddressSuggestionsProps {
  addresses: DeliveryAddress[];
}

const AddressSuggestions = ({ addresses = [] }: AddressSuggestionsProps) => {
  return (
    <SectionContainer style={styles.container}>
      {addresses.map((address, index) => (
        <AddressItem key={index} address={address} />
      ))}
    </SectionContainer>
  );
};

const styles: Styles = {
  container: {
    padding: 0,
  },
};

export default AddressSuggestions;
